import { ContributionClassRolesDDL } from 'types/contribution';

const getOrderedRoles = (
  roles: string[],
  contributionClassNames?: ContributionClassRolesDDL
): string[] => {
  if (!contributionClassNames) {
    return [];
  }
  const groupedSortOrder = Object.values(contributionClassNames).map(
    (className) => className.key
  );
  return groupedSortOrder.reduce((acc, val) => {
    const role = roles.find((role) => role === val);
    if (role) {
      return acc.concat(role);
    }
    return acc;
  }, [] as string[]);
};

export const getRolesLabel = (
  roles: string[],
  contributionClassNames?: ContributionClassRolesDDL
) => {
  const orderedRoles = getOrderedRoles(roles, contributionClassNames);

  if (orderedRoles.length === 0) {
    return ['No Role Selected'];
  }

  return orderedRoles.map((role) =>
    role ? contributionClassNames?.[role]?.name || role : 'No Role Selected'
  );
};
